import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { createSearchParams, useNavigate } from 'react-router-dom';

import API from 'configs/API';
import Routes from 'utils/Route';
import { axiosPost } from 'utils/apis/axios';
import { ToastTopHelper } from 'utils/utils';

const rejectCertificateRequest = async (certificateRequestId, formData) => {
  const { data } = await axiosPost(
    false,
    API.ARTWORK.REJECT_CERTIFICATE_REQUEST(certificateRequestId),
    formData,
  );
  return data;
};

const useRejectCertificate = (certificateRequestId) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData) => rejectCertificateRequest(certificateRequestId, formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API.ARTWORK.LIST_CERTIFICATE_REQUEST] });
      ToastTopHelper.success(t('reject_success'));
      navigate(
        {
          pathname: Routes.ManageCertificate,
          search: createSearchParams({ tab: 1 }).toString(),
        },
        {
          replace: true,
        },
      );
    },
  });
};

export default useRejectCertificate;
